<!-- Truncated display-->
<div class="highlighted-topline highlighted-topline--phone"
     *ngIf="truncate && topline?.appliedToplineValue">
  <a *ngIf="topline?.appliedToplineValue && !isDoNotContact()"
     style="text-overflow:ellipsis"
     href="tel:{{topline.appliedToplineValue.number}}"
     class="link link--noline color--gray--005 txt-fw-500">
    {{topline.appliedToplineValue?.number | phone}}
    {{topline.appliedToplineValue?.ext ? 'Ext. ' + topline.appliedToplineValue.ext : ''}}
  </a>
  <span *ngIf="topline?.appliedToplineValue && isDoNotContact()"
        style="text-overflow:ellipsis"
        class="color--gray--007 txt-fw-500">
    {{topline.appliedToplineValue?.number | phone}}
    {{topline.appliedToplineValue?.ext ? 'Ext. ' + topline.appliedToplineValue.ext : ''}}
  </span>
  <i class="fas fa-ban color--red ml-0025"
     *ngIf="isDoNotContact()"
     [matTooltip]="'Do not contact'"
     [matTooltipPosition]="'left'"></i>
  <i class="far fa-check pair__verified ml-0025"
     *ngIf="topline.appliedToplineValue?.status === 'verified'"
     [matTooltip]="'Confirmed'"></i>
  <i class="far fa-bell-on pair__verified ml-0025"
     *ngIf="topline.appliedToplineValue?.subscribed"
     [matTooltip]="'Subscribed'"></i>
</div>

<div *ngIf="!truncate"
     class="toplines__pair toplines__pair--phone col__ flexAlign--baseline"
     [ngClass]="{'toplines__pair--empty':!topline?.appliedToplineValue}">
  <div class="pair__icon">
    <i class="fal fa-fw fa-phone"
       matTooltip="Phone"></i>
    <span class="screen-reader">Phone</span>
  </div>
  <div class="pair__content truncate">
    <span *ngIf="topline.appliedToplineValue"
          class="pair__label">Phone</span>
    <span *ngIf="!topline.appliedToplineValue"
          data-test-id="toplineAddPhoneLink"
          (click)="onAddClicked()"
          class="pair__link link link--noline">Add
      Phone</span>

    <a *ngIf="topline.appliedToplineValue?.number && !isDoNotContact() && !isBad()"
       href="tel:{{topline.appliedToplineValue.number}}"
       class="pair__link link link--noline link--black">
      {{topline.appliedToplineValue?.number | phone}}
      {{topline.appliedToplineValue?.ext ? 'Ext. ' + topline.appliedToplineValue.ext : ''}}
      <i class="far fa-check pair__verified ml-0025"
         *ngIf="topline.appliedToplineValue?.status === 'verified'"
         [matTooltip]="'Confirmed'"
         [matTooltipPosition]="'left'"></i>
      <i class="far fa-bell-on pair__verified ml-0050"
         *ngIf="topline.appliedToplineValue?.subscribed"
         [matTooltip]="'Subscribed'"
         [matTooltipPosition]="'left'"></i>
    </a>

    <span *ngIf="topline.appliedToplineValue?.number && isDoNotContact() && !isBad()"
          class="pair__link color--gray--007">
      {{topline.appliedToplineValue?.number | phone}}
      {{topline.appliedToplineValue?.ext ? 'Ext. ' + topline.appliedToplineValue.ext : ''}}
      <i class="fas fa-ban color--red ml-0025"
         [matTooltip]="'Do not contact'"
         [matTooltipPosition]="'left'"></i>
      <i class="far fa-check pair__verified ml-0050"
         *ngIf="topline.appliedToplineValue?.status === 'verified'"
         [matTooltip]="'Confirmed'"
         [matTooltipPosition]="'left'"></i>
      <i class="far fa-bell-on pair__verified ml-0050"
         *ngIf="topline.appliedToplineValue?.subscribed"
         [matTooltip]="'Subscribed'"
         [matTooltipPosition]="'left'"></i>
    </span>

   <span *ngIf="topline?.appliedToplineValue && !isDoNotContact() && isBad()"
            data-test-id="toplineEmail"
            class="pair__link color--gray--007">
            {{topline.appliedToplineValue?.number | phone}}
            {{topline.appliedToplineValue?.ext ? 'Ext. ' + topline.appliedToplineValue.ext : ''}}

         <i class="far fa-times-circle pair__red ml-0050"
           *ngIf="topline.appliedToplineValue?.status === 'bad'"
           [matTooltip]="'Marked as Bad'"
           [matTooltipPosition]="'left'"></i>
      </span>

      <span *ngIf="topline.appliedToplineValue?.number && isDoNotContact() && isBad()"
          class="pair__link color--gray--007">
      {{topline.appliedToplineValue?.number | phone}}
      {{topline.appliedToplineValue?.ext ? 'Ext. ' + topline.appliedToplineValue.ext : ''}}
      <i class="fas fa-ban color--red ml-0025"
         [matTooltip]="'Do not contact'"
         [matTooltipPosition]="'left'"></i>
      <i class="far fa-check pair__verified ml-0050"
         *ngIf="topline.appliedToplineValue?.status === 'verified'"
         [matTooltip]="'Confirmed'"
         [matTooltipPosition]="'left'"></i>
      <i class="far fa-bell-on pair__verified ml-0050"
         *ngIf="topline.appliedToplineValue?.subscribed"
         [matTooltip]="'Subscribed'"
         [matTooltipPosition]="'left'"></i>
      <i class="far fa-times-circle pair__red ml-0050"
         *ngIf="topline.appliedToplineValue?.status === 'bad'"
         [matTooltip]="'Marked as Bad'"
         [matTooltipPosition]="'left'"></i>
      </span>
  </div>
</div>
